'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactstrap = require('reactstrap');
var _inputsStyles = require('../inputsStyles/inputsStyles');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var handleLabel = function handleLabel(label, htmlFor, type) {
  var marginBottom = '2px';
  var visibility = 'visible';
  if (label === 'WITHOUT_LABEL') {
    visibility = 'hidden';
  }
  if (type !== 'select') {
    marginBottom = '6px';
  }
  if (label === undefined) {
    return null;
  }
  return _react2.default.createElement(_inputsStyles.StyledLabel, {
    style: {
      visibility: visibility,
      marginBottom: marginBottom
    },
    htmlFor: htmlFor
  }, label);
};
var TextInputContainer = function TextInputContainer(_ref) {
  var htmlFor = _ref.htmlFor,
    children = _ref.children,
    label = _ref.label,
    size = _ref.size,
    type = _ref.type,
    customstyle = _ref.customstyle;
  return _react2.default.createElement(_inputsStyles.StyledTextInputContainer, {
    'data-testid': 'StyledTextInputContainer',
    customstyle: customstyle,
    className: size
  }, _react2.default.createElement(_reactstrap.FormGroup, {
    style: {
      marginBottom: 0,
      backgroundColor: 'transparent'
    },
    cols: 'true'
  }, handleLabel(label, htmlFor, type), children));
};
TextInputContainer.defaultProps = {
  isRequired: false,
  renderCustomInput: function renderCustomInput() {
    return null;
  },
  customStyle: {}
};
exports.default = TextInputContainer;